import { render, staticRenderFns } from "./SubmissionDetailWidget.vue?vue&type=template&id=269f345b&scoped=true"
import script from "./SubmissionDetailWidget.vue?vue&type=script&lang=js"
export * from "./SubmissionDetailWidget.vue?vue&type=script&lang=js"
import style0 from "./SubmissionDetailWidget.vue?vue&type=style&index=0&id=269f345b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269f345b",
  null
  
)

export default component.exports